import {
  addDays,
  startOfWeek,
  endOfWeek,
  addWeeks,
  startOfMonth,
  endOfMonth,
  addMonths, startOfYear, endOfYear, addYears,
} from 'date-fns';

// eslint-disable-next-line no-unused-vars
import { DefinedRange } from './types';

export const getDefaultRanges = (date: Date, locale?: Locale): DefinedRange[] => [
  {
    label: 'Сегодня',
    startDate: date,
    endDate: date,
  },
  {
    label: 'Вчера',
    startDate: addDays(date, -1),
    endDate: addDays(date, -1),
  },
  {
    label: 'Текущая неделя',
    startDate: startOfWeek(date, {locale}),
    endDate: endOfWeek(date, {locale}),
  },
  {
    label: 'Прошлая неделя',
    startDate: startOfWeek(addWeeks(date, -1), {locale}),
    endDate: endOfWeek(addWeeks(date, -1), {locale}),
  },
  {
    label: 'Последние 7 дней',
    startDate: addWeeks(date, -1),
    endDate: date,
  },
  {
    label: 'Текущий месяц',
    startDate: startOfMonth(date),
    endDate: endOfMonth(date),
  },
  {
    label: 'Прошлый месяц',
    startDate: startOfMonth(addMonths(date, -1)),
    endDate: endOfMonth(addMonths(date, -1)),
  },
  {
    label: 'Текущий год',
    startDate: startOfYear(date),
    endDate: endOfYear(date),
  },
  {
    label: 'Прошлый год',
    startDate: startOfYear(addYears(date, -1)),
    endDate: endOfYear(addYears(date, -1)),
  },
];
